

document.addEventListener('DOMContentLoaded', () => {
	const section = document.querySelector('.buchung');
	if (!section) return;

	const slider = section.querySelector('.radio');
	const left = section.querySelector('.left');
	const right = section.querySelector('.right');
	if (!slider || !left || !right) return;

	const move = direction => {
		const item = slider.querySelector('label, .strecke, .event');
		const gap = parseInt(getComputedStyle(slider).gap) || 0;
		const width = item ? item.offsetWidth + gap : slider.clientWidth * .8;

		slider.scrollBy({
			left: width * direction,
			behavior: 'smooth'
		});
	};

	left.addEventListener('click', () => move(-1));
	right.addEventListener('click', () => move(1));
});